import { createApiCallActions } from 'src/app/common/store/generic.actions';
import { CountyModel } from './types';

export const countyActions = {
  get: createApiCallActions<CountyModel[]>('county', 'get'),
  getById: createApiCallActions<CountyModel>('county', 'getById'),
};

export type CountyAction = typeof countyActions;
